import { InjectionToken } from '@angular/core';

export const FEATURE_NAME = '@zerops/zef/entities';
export const METADATA_TOKEN = new InjectionToken<string>('zef-entities/metadata');
export const API_PREFIX = new InjectionToken<string>('zef-entities/api-prefix');
